import { FormattedMessage, useIntl } from "react-intl";
import { Tooltip } from "@/components/common/Tooltip";
import type { AnalysedDocumentCountState } from "./use-analysed-document-count";

export function AnalysedDocumentCount({ state, compact = false }: { state: AnalysedDocumentCountState; compact?: boolean }) {
  const intl = useIntl();
  if (state.status === "unavailable") return null;
  if (state.status === "loading") {
    return <span role="status" aria-label={intl.formatMessage({ id: "grow.assess.documentsLoading", defaultMessage: "Loading analysed documents" })}>…</span>;
  }
  if (state.status === "error") {
    return (
      <Tooltip content={<FormattedMessage id="grow.assess.documentsError" defaultMessage="Analysed documents could not be loaded." />}>
        <span aria-label={intl.formatMessage({ id: "grow.assess.documentsError", defaultMessage: "Analysed documents could not be loaded." })}>–</span>
      </Tooltip>
    );
  }
  return (
    <Tooltip content={<FormattedMessage id="grow.assess.documentsCountHint" defaultMessage="Across your Power Profile, counting each document once. Only documents with stored Powers evidence count; uploads and analyses with no findings are not included." />}>
      <span>{compact ? state.count : <FormattedMessage id="grow.assess.documentsCount" defaultMessage="{count, plural, one {# document analysed} other {# documents analysed}}" values={{ count: state.count }} />}</span>
    </Tooltip>
  );
}
